module.exports = __webpack_public_path__ + "assets/close.f27efc8e.svg";